import { createSlice } from "@reduxjs/toolkit";

export const slice = createSlice({
  name: "appParamSlice",
  initialState: {
    allAppParams: {},
    clubCategories: [],
    futureOrdersData: [],
    pastOrdersData: [],
  },
  reducers: {
    updateAllAppParams: (state, action) => {
      state.allAppParams = action.payload;
    },
    updateAllClubParams: (state, action) => {
      state.clubCategories = action.payload;
    },
    updateAllFutureOrders: (state, action) => {
      state.futureOrdersData = action.payload;
    },
    updateAllPastOrders: (state, action) => {
      state.pastOrdersData = action.payload;
    },
  },
});

export const { updateAllAppParams, updateAllClubParams, updateAllFutureOrders, updateAllPastOrders } = slice.actions;

export const selectPastOrdersData = (state) => {
  if (!state.appParamSlice.pastOrdersData) return [];
  return [...state.appParamSlice.pastOrdersData].sort((a, b) => {
    const dateA = new Date(a.SupplyDate);
    const dateB = new Date(b.SupplyDate);
    return dateB - dateA;
  });
};

export default slice.reducer;
